export default "__VITE_ASSET__C9vzaCLd__"